type FindingUrlParams = {
  id: string;
  mrn: string;
  __typename: string;
};

export function buildFindingUrl(
  finding: FindingUrlParams,
  assetId: string,
  spaceId: string,
  jobId?: string,
): string {
  const base = `/space/inventory/${assetId}`;
  const params = new URLSearchParams({ spaceId });

  if (jobId) {
    params.set("jobId", jobId);
  }

  switch (finding.__typename) {
    case "CveFinding":
      return `${base}/vulnerabilities/${encodeURIComponent(finding.id)}?${params}`;
    case "AdvisoryFinding":
      return `${base}/advisories/${encodeURIComponent(finding.id)}?${params}`;
    case "CheckFinding":
      params.set("checkMrn", finding.mrn);
      return `${base}/check?${params}`;
    case "GenericFinding":
      params.set("genericFindingMrn", finding.mrn);
      return `${base}/generic-finding?${params}`;
    default:
      return base;
  }
}
